import * as THREE from 'three';

// Canonical set of marker shapes an admin can assign to a marker category. `value` is what
// gets persisted on the category (MarkerType.shape); `label`/`icon` drive the admin picker.
// Keep this list in sync with createShapeGeometry below — every value must have a case.
export const MARKER_SHAPES = [
  { value: 'sphere', label: 'Sphere', icon: 'mdi-circle-outline' },
  { value: 'cube', label: 'Cube', icon: 'mdi-cube-outline' },
  { value: 'cone', label: 'Cone', icon: 'mdi-triangle-outline' },
  { value: 'pyramid', label: 'Pyramid', icon: 'mdi-pyramid' },
  { value: 'cylinder', label: 'Cylinder', icon: 'mdi-rectangle-outline' },
  { value: 'capsule', label: 'Capsule', icon: 'mdi-pill' },
  { value: 'triangularprism', label: 'Triangular Prism', icon: 'mdi-vector-triangle' },
  { value: 'hexprism', label: 'Hexagonal Prism', icon: 'mdi-hexagon' },
  { value: 'torus', label: 'Torus', icon: 'mdi-circle-double' },
  { value: 'octahedron', label: 'Octahedron', icon: 'mdi-rhombus-outline' },
  { value: 'tetrahedron', label: 'Tetrahedron', icon: 'mdi-triangle' },
  { value: 'dodecahedron', label: 'Dodecahedron', icon: 'mdi-hexagon-outline' },
];

export const DEFAULT_MARKER_SHAPE = 'sphere';
export const DEFAULT_MARKER_COLOR = '#5E94A8';

// A small, curated palette for the admin colour picker swatches (markers should be vivid and
// distinguishable against the point cloud). The picker still allows any custom hex.
export const MARKER_COLOR_SWATCHES = [
  '#FF5E3A', '#FF9F1C', '#FFD23F', '#4ADE80',
  '#2EC4B6', '#5E94A8', '#3B82F6', '#8B5CF6',
  '#C78BA3', '#F472B6', '#EF4444', '#E0E0E0',
];

// Build the three.js geometry for a shape key. Sizes are tuned to read at a comparable scale
// in the viewer. Unknown / missing keys fall back to a sphere so a marker always renders.
export function createShapeGeometry(shape) {
  switch (shape) {
    case 'cube':
      return new THREE.BoxGeometry(0.8, 0.8, 0.8);
    case 'cone':
      return new THREE.ConeGeometry(0.5, 1.0, 24);
    case 'pyramid':
      return new THREE.ConeGeometry(0.55, 0.9, 4);
    case 'cylinder':
      return new THREE.CylinderGeometry(0.45, 0.45, 0.9, 24);
    case 'capsule':
      return new THREE.CapsuleGeometry(0.35, 0.6, 8, 16);
    case 'triangularprism':
      return new THREE.CylinderGeometry(0.55, 0.55, 0.85, 3);
    case 'hexprism':
      return new THREE.CylinderGeometry(0.5, 0.5, 0.85, 6);
    case 'torus':
      return new THREE.TorusGeometry(0.45, 0.16, 16, 48);
    case 'octahedron':
      return new THREE.OctahedronGeometry(0.6);
    case 'tetrahedron':
      return new THREE.TetrahedronGeometry(0.65);
    case 'dodecahedron':
      return new THREE.DodecahedronGeometry(0.55);
    case 'sphere':
    default:
      return new THREE.SphereGeometry(0.45, 18, 18);
  }
}
